import { createSlice } from "@reduxjs/toolkit";
import { IPaymentOptions } from "../../config/commonInterfaces";

export interface IPaymentStore {
  optionsObj: Record<string, IPaymentOptions[]>;
}

const initialState: IPaymentStore = { optionsObj: {} };

export const payment = createSlice({
  name: "paymentStore",
  initialState,
  reducers: {
    callFetchPaymentOptions: (state, action) => {
    },

    /**
     * Save newly fetched payment options
     * @param state 
     * @param action 
     */
    callFetchPaymentOptionsSuccess: (state, action) => {
      if (!state?.optionsObj)
        state = initialState;
      const data = action.payload.data?.reduce((prv:any,item:any)=>{
        return {...prv,[item?.name]:true}
      },{});
      state.optionsObj = data;
    },

    //trigger mpesa validation
    callMPESAValidationApi: (state, action) => {
    },
    //trigger mpesa enquiry api
    callMPESAEnquiryApi: (state, action) => {
    },

    callTransactionAmountValidation: (state, action) => {
    },
    callConvertCurrency: (state, action) => {

    },
    callTransactionStatus: (state, action) => {
      // This action is used to trigger the transaction status check
    }
  }
})

export const {
  callFetchPaymentOptions,
  callFetchPaymentOptionsSuccess,
  callMPESAValidationApi,
  callMPESAEnquiryApi,
  callTransactionAmountValidation,
  callConvertCurrency,
  callTransactionStatus
} = payment.actions;

export default payment.reducer;